import React, { useState, useEffect } from 'react';

const CensorProfanity = ({ text }) => {
  const [profanityFilterOn, setProfanityFilterOn] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem('user')}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          }
        );
        if (userResponse.ok) {
          const userResult = await userResponse.json();
          setProfanityFilterOn(userResult.attributes.ProfanityFilter)
        } else {
          console.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  if (!profanityFilterOn) {
    return text;
  }
  // Replace profane words with asterisks or other characters
  return text.replace(/\b(fuck|hell|shit|bitch)\b/gi, "****");
};

export default CensorProfanity;
